import type { FieldValues } from "react-hook-form";
import { FormComponent } from "../FormComponent";
import { FormMoney, type FormMoneyProps } from "../fields/FormMoney";
import type { FormComponentProps } from "../types";

export type FormCurrencyComponentProps<TFieldValues extends FieldValues> =
	FormComponentProps<TFieldValues> & Omit<FormMoneyProps<TFieldValues>, "control">;

export const FormCurrencyComponent = <TFieldValues extends FieldValues>(
	props: FormCurrencyComponentProps<TFieldValues>,
) => {
	const { formMethods, ...restProps } = props;
	const { control } = formMethods;
	return (
		<FormComponent {...props}>
			<FormMoney control={control} {...restProps} />
		</FormComponent>
	);
};
